
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_18005_4844)"}},[_c('circle',{attrs:{"cx":"7","cy":"7","r":"7","fill":"#2EC100"}}),_c('path',{attrs:{"d":"M6.375 3C4.512 3 3 4.345 3 6c0 .945.486 1.78 1.251 2.33L3.9 9.5l1.125-.75c.4.155.841.25 1.31.25a2.862 2.862 0 01-.185-1c0-1.655 1.409-3 3.15-3 .085 0 .171 0 .252.015C9.093 3.845 7.851 3 6.375 3zm-1.35 1.25c.12 0 .234.053.318.146a.549.549 0 010 .707.45.45 0 01-.146.109.411.411 0 01-.172.038.428.428 0 01-.318-.146.53.53 0 01-.132-.354.53.53 0 01.132-.354.428.428 0 01.318-.146zm2.25 0c.12 0 .234.053.318.146a.53.53 0 01.132.354.53.53 0 01-.132.354.428.428 0 01-.318.146.428.428 0 01-.318-.146.53.53 0 01-.132-.354.53.53 0 01.132-.354.428.428 0 01.318-.146zM9.3 5.5C7.81 5.5 6.6 6.62 6.6 8s1.21 2.5 2.7 2.5c.301 0 .59-.04.86-.125l.94.625-.279-.935C11.528 9.61 12 8.855 12 8c0-1.38-1.21-2.5-2.7-2.5zm-.9 1.25c.12 0 .234.053.318.146a.53.53 0 01.132.354.53.53 0 01-.132.354.428.428 0 01-.318.146.428.428 0 01-.318-.146.53.53 0 01-.132-.354.53.53 0 01.132-.354.428.428 0 01.318-.146zm1.8 0c.12 0 .234.053.318.146a.53.53 0 01.132.354.53.53 0 01-.132.354.429.429 0 01-.318.146.429.429 0 01-.318-.146.53.53 0 01-.132-.354.53.53 0 01.132-.354.429.429 0 01.318-.146z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_18005_4844"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h14v14H0z"}})])])])
          )
        }
      }
    